'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SCHEDULE_FREQUENCY, getFormattedDayLabels, getFormattedTimeLabels } from '../../../lib/schedulingLogic';
import { useControlsContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareScheduleSummary = () => {
  const {
    shareScheduleFrequency,
    shareScheduleOnDays,
    shareScheduleAtHour,
    isUtc
  } = useControlsContext();
  const optionsField = Object.assign({
    days: I18n.formatList(getFormattedDayLabels({
      scheduleFrequency: shareScheduleFrequency,
      isUtc,
      scheduleOnDays: shareScheduleOnDays
    }))
  }, getFormattedTimeLabels({
    scheduleAtHour: shareScheduleAtHour,
    isUtc
  }));
  if (shareScheduleFrequency === SCHEDULE_FREQUENCY.DAILY) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.scheduleSummary.dailyDescription",
      options: Object.assign({}, getFormattedTimeLabels({
        scheduleAtHour: shareScheduleAtHour,
        isUtc
      }))
    });
  }
  if (shareScheduleOnDays.length) {
    if (shareScheduleFrequency === SCHEDULE_FREQUENCY.WEEKLY) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.scheduleSummary.weeklyDescription",
        options: optionsField
      });
    } else if (shareScheduleFrequency === SCHEDULE_FREQUENCY.MONTHLY) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.scheduleSummary.monthlyDescription",
        options: optionsField
      });
    }
  }
  return null;
};
export default ShareScheduleSummary;